import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginContextProvider } from '@dxp-module/login'
import { ClassNameMap } from '@mui/material'
import { SignupClasses } from '@dxp-module/themes/src'
import ROUTES from '../../../common/enum/Routes'
import SignupContainer from './SignupContainer'

type SignupRedirectProps = {
  classes?: Partial<ClassNameMap<SignupClasses>>
}

const SignupRedirect: FunctionComponent<SignupRedirectProps> = ({
  classes,
}) => {
  const navigate = useNavigate()

  const onLoginSuccess = () => {
    navigate({ pathname: ROUTES.MYACCOUNT_BASE })
  }

  return (
    <LoginContextProvider onLoginSuccess={onLoginSuccess}>
      <SignupContainer classes={classes} />
    </LoginContextProvider>
  )
}

export default SignupRedirect
